import React from 'react';

import { MenuItem } from '@/components/header';
import { IconCommunication, IconContainer, IconContract, IconDashboard, IconEdit2, IconReports } from '@/components/icons';
import { ALLOWED_TO_ADDITIONAL_DISCHARGES_SUBJECT } from '@/features/additional-discharges';
import { useAbility } from '@/features/auth';

export function useMenuItems() {
  const ability = useAbility();

  const menuItems: MenuItem[] = [
    {
      key: 'dashboard',
      url: '/',
      icon: <IconDashboard size="sm" />,
      isVisible: true,
    },
    {
      key: 'contracts',
      url: '/contracts',
      icon: <IconContract size="sm" />,
      isVisible: true,
    },
    {
      key: 'serviceHistory',
      url: '/service-history',
      icon: <IconContainer size="sm" />,
      isVisible: true,
    },
    {
      key: 'invoices',
      url: '/invoices',
      icon: <IconEdit2 size="sm" />,
      isVisible: true,
    },
    {
      key: 'additionalDischarges',
      url: '/additional-discharges',
      icon: <IconEdit2 size="sm" />,
      isVisible: ability?.can('read', ALLOWED_TO_ADDITIONAL_DISCHARGES_SUBJECT) || false,
    },
    {
      key: 'reports',
      url: '/reports',
      icon: <IconReports size="sm" />,
      isVisible: import.meta.env.VITE_APP_ENV === 'staging',
    },
    {
      key: 'communication',
      url: '/communication',
      icon: <IconCommunication size="sm" />,
      isVisible: import.meta.env.VITE_APP_ENV === 'staging',
    },
  ];

  return { menuItems };
}
